import Actions from "./tipiCombustibileActions";
import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";

export class TipiCombustibileStore extends AbstractGetAllStore<string> {
    constructor() {
        super(l => l);
        Dispatcher
            .onfunction(Actions.getAll, data => this.setAll(data))
            ;
    }
    public useAll = () => this.useAllWithAction(() => Actions.getAll());
}

export default new TipiCombustibileStore();